import {
  Cell,
  Legend,
  Pie,
  PieChart as RechartsPieChart,
  ResponsiveContainer,
  LegendProps,
} from 'recharts';
import { BoxProps } from '@mui/material';

import { surveyChartDataColors } from '@occc-app/themes/colors';

import { buildRenderLegend } from './build-render-legend';
import { renderCustomizedLabel } from './render-customized-label';
import { PiePieceItem } from './pie-chart.types';

type PieChartProps = {
  items: PiePieceItem[];
  legendWrapperStyle?: LegendProps['wrapperStyle'];
  legendContentWrapperProps?: BoxProps;
};

export const PieChart = ({
  items,
  legendWrapperStyle,
  legendContentWrapperProps,
}: PieChartProps) => {
  const totalValue = items.reduce((previousValue, { value }) => previousValue + value, 0);
  const renderLegend = buildRenderLegend({ wrapperProps: legendContentWrapperProps, totalValue });
  return (
    <ResponsiveContainer width='100%' height='100%'>
      <RechartsPieChart>
        <Pie
          data={items}
          labelLine={false}
          label={renderCustomizedLabel}
          innerRadius='30%'
          dataKey='value'
          legendType='square'
          minAngle={14}
        >
          {items.map((entry, index) => {
            return (
              <Cell
                key={`cell-${index}`}
                fill={surveyChartDataColors[index % surveyChartDataColors.length]}
              />
            );
          })}
        </Pie>

        <Legend
          wrapperStyle={{
            left: '55%',
            right: 5,
            ...legendWrapperStyle,
          }}
          layout='vertical'
          align='right'
          verticalAlign='middle'
          content={renderLegend}
        />
      </RechartsPieChart>
    </ResponsiveContainer>
  );
};
